exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".area-details {\n  margin: 1em auto;\n  width: 1000px;\n  background: white;\n  clear: both; }\n  .area-details .area-details-container {\n    margin: 1.7em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; }\n    .area-details .area-details-container .area-details-table {\n      border-collapse: collapse; }\n      .area-details .area-details-container .area-details-table td {\n        border-bottom: 1px solid #aaaaaa;\n        padding: .5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/clients/views/areaDetailsView/areaDetailsView.component.scss
// module id = ./src/app/modules/clients/views/areaDetailsView/areaDetailsView.component.scss
// module chunks = main